import React from "react";
import InquiryStatusBadge from "../../sales/inquiry/components/InquiryStatusBadge";
import { formatRupeeAmount } from "../../sales/inquiry/utils/currency";

interface InquiryRow {
  id: number;
  client_name: string;
  contact_details: string;
  client_segment: string;
  current_stage: string;
  architect_name: string;
  probability: string;
  current_status: string | null;
  inquiry_assigned_to: string;
  dp_details: string | null;
  quotation: string | null;
  last_activity: string | null;
}

interface Props {
  data: InquiryRow[];
  selectedIds: number[];
  isSelectAll: boolean;
  onSelect: (id: number) => void;
  onSelectAll: () => void;
}

const BulkTransferTable: React.FC<Props> = ({
  data,
  selectedIds,
  isSelectAll,
  onSelect,
  onSelectAll,
}) => {

  const formatDate = (date?: string | null) => {
    if (!date) return "-";

    // Already dd-mm-yyyy
    if (/^\d{2}-\d{2}-\d{4}$/.test(date)) {
      return date;
    }

    let d: Date;

    // Handle MM/DD/YY or MM/DD/YYYY
    if (date.includes("/")) {
      const parts = date.split("/");

      let month = Number(parts[0]);
      let day = Number(parts[1]);
      let year = Number(parts[2]);

      // convert 2-digit year → 4-digit
      if (year < 100) {
        year += 2000;
      }

      d = new Date(year, month - 1, day);
    } else {
      // default (ISO format etc.)
      d = new Date(date);
    }

    if (isNaN(d.getTime())) return "-";

    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();

    return `${day}-${month}-${year}`;
  }; return (
    <div className="inquiry-table-wrapper table-responsive">
      <table className="table inquiry-table align-middle">
        <thead>
          <tr>
            {/* ✅ CHECKBOX COLUMN */}
            <th style={{ textAlign: "center" }}>
              <input
                type="checkbox"
                checked={isSelectAll || (data.length > 0 && selectedIds.length === data.length)}
                onChange={onSelectAll}
              />
            </th>
            <th>Inquiry Id</th>
            <th>Client Name</th>
            <th>Contact Details</th>
            <th>Client Segment</th>
            <th>Current Stage</th>
            <th>Architect</th>
            <th>RFQ</th>
            <th>Quotation</th>
            <th>Probability</th>
            <th>Status</th>
            <th>Assigned To</th>
            <th>Last Activity</th>
          </tr>
        </thead>

        <tbody>
          {data.length === 0 ? (
            <tr>
              <td colSpan={12} className="text-center py-4">
                No inquiries found
              </td>
            </tr>
          ) : (
            data.map((row) => (
              <tr key={row.id}>
                {/* ✅ ROW CHECKBOX */}
                <td style={{ textAlign: "center" }}>
                  <input
                    type="checkbox"
                    checked={
                      isSelectAll
                        ? !selectedIds.includes(row.id)
                        : selectedIds.includes(row.id)
                    }
                    onChange={() => onSelect(row.id)}
                  />
                </td>
                <td>{row.id || "-"}</td>
                <td>{row.client_name || "-"}</td>
                <td>{row.contact_details || "-"}</td>
                <td>{row.client_segment || "-"}</td>
                <td>{row.current_stage || "-"}</td>
                <td>{row.architect_name || "-"}</td>
                <td style={{ textAlign: "right" }}>{formatRupeeAmount(row.dp_details)}</td>
                <td style={{ textAlign: "right" }}>{formatRupeeAmount(row.quotation)}</td>
                <td>{row.probability || "-"}</td>

                <td>
                  {row.current_status ? (
                    <InquiryStatusBadge status={row.current_status} />
                  ) : (
                    "-"
                  )}
                </td>

                <td>{row.inquiry_assigned_to || "-"}</td>
                <td style={{ textAlign: "center" }}>
                  {formatDate(row.last_activity)}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default BulkTransferTable;